export const initialState = {
    loader: false,
    orderList: [],
    error: ''
}